"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _list = _interopRequireDefault(require("../components/Category/list.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CategoryList: _list.default
  },
  data: function data() {
    return {
      constants: this.$constants
    };
  }
};